import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import mg from './locales/mg.json';

export const LANGUAGES = [
    { code: 'fr', label: 'FR', name: 'Français' },
    { code: 'en', label: 'EN', name: 'English' },
    { code: 'mg', label: 'MG', name: 'Malagasy' },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            fr: { translation: fr },
            en: { translation: en },
            mg: { translation: mg },
        },
        // French is the site's historical language and the API's base fields
        fallbackLng: 'fr',
        supportedLngs: ['fr', 'en', 'mg'],
        load: 'languageOnly',
        interpolation: {
            // React already escapes rendered strings
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

// Keep <html lang="..."> in sync for accessibility and SEO
i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.resolvedLanguage || 'fr';

export default i18n;
